import { render, staticRenderFns } from "./KSADashboard.vue?vue&type=template&id=f0317414"
import script from "./KSADashboard.vue?vue&type=script&lang=js"
export * from "./KSADashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports